<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Grupy uprawnień</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li class="active">
          <strong>Grupy uprawnień</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Grupy uprawnień</h5>
            <span class="ibox-toggle" @click="isMainOpen = !isMainOpen">
              <i :class="chevronMainClass"></i>
            </span>
          </div>
          <div class="ibox-content" v-show="isMainOpen">
            <router-link v-if="canAddGroup" to="/groups/create">
              <button class="btn btn-sm btn-primary">Dodaj</button>
            </router-link>
            <div class="row">
              <div class="col-sm-12 m-b-xs">
                <div class="form-group">
                  <label class="control-label col-sm-2">
                    Wpisz liczbę wierszy:
                  </label>
                  <div class="col-sm-2">
                    <input
                      class="form-control inputClass"
                      type="text"
                      v-model="rowsPerPage"
                      @change="setRowsPerPage"
                      @click="isSearch = false"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 m-b-xs" v-if="items">
                <button @click="resetFilters" class="btn btn-primary btn-xs">
                  <i class="fa fa-refresh"></i>
                </button>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input type="number" v-model="serverOptions.page" /> -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="serverOptions.page = serverOptions.page - 1"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="serverOptions.page = serverOptions.page + 1"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
                <EasyDataTable
                  v-model:server-options="serverOptions"
                  :server-items-length="itemsAll"
                  :headers="headers"
                  :items="items"
                  :clickRowToExpand="true"
                  :loading="loading"
                  @expand-row="editGroup"
                  alternating
                  multi-sort
                  border-cell
                  @update-sort="updateSort"
                  class="table-search"
                >
                  <template #header="header">
                    <span v-if="header.text">{{ header.text }}</span>
                    <input
                      class="table-search"
                      type="text"
                      v-if="header.search"
                      v-model="searchValue[header.value]"
                      @keyup="search"
                      @click="isSearch = true"
                    />
                  </template>
                  <template #expand="item">
                    <div class="row">
                      <div class="col-lg-12">
                        <div class="ibox float-e-margins">
                          <div class="ibox-title">
                            <h5>Edycja grupy uprawnień {{ item.name }}</h5>
                            <span
                              class="ibox-toggle"
                              @click="isEditOpen = !isEditOpen"
                            >
                              <i :class="chevronEditClass"></i>
                            </span>
                          </div>
                          <div class="ibox-content" v-show="isEditOpen">
                            <div class="form-horizontal">
                              <div class="ibox-content">
                                <div class="form-group">
                                  <label
                                    for="groupname"
                                    class="control-label col-sm-2"
                                  >
                                    Nazwa
                                  </label>
                                  <div class="col-sm-10">
                                    <input
                                      id="groupname"
                                      v-model="groupObj.name"
                                      name="username"
                                      type="text"
                                      class="form-control inputClass"
                                      placeholder="Nazwa"
                                      required="required"
                                    />
                                    <div
                                      v-if="errorsAdminData?.data?.name"
                                      class="has-error"
                                    >
                                      <span class="help-block">
                                        {{ errorsAdminData.data.name[0] }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    Uprawnienia
                                  </label>
                                  <div class="col-sm-10">
                                    <Multiselect
                                      v-model="groupObj.permissions"
                                      mode="tags"
                                      placeholder="Uprawnienia"
                                      track-by="name"
                                      label="name"
                                      :close-on-select="false"
                                      :searchable="true"
                                      :options="permissionsList"
                                    >
                                    </Multiselect>
                                    <div
                                      v-if="
                                        !groupObj.permissions?.length &&
                                        showErrors
                                      "
                                      class="has-error"
                                    >
                                      <span class="help-block">
                                        To pole nie może być puste
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="hr-line-dashed"></div>

                                <div class="form-group">
                                  <div class="col-sm-4 col-sm-offset-2">
                                    <button
                                      @click="cancel"
                                      class="btn btn-white"
                                    >
                                      Anuluj
                                    </button>
                                    <button
                                      v-if="canChangeGroup"
                                      @click="saveEdit"
                                      class="btn btn-primary"
                                    >
                                      Zapisz
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template #item-user_count="item">
                    <span
                      class="group-users-count"
                      @mouseover="groupUsersList(item.pk)"
                    >
                      {{ item.user_count }}

                      <div
                        v-if="usersPk === item.pk && item.user_count > 0"
                        class="group-users-list"
                      >
                        <template v-for="(user, key) in users" :key="key">
                          <router-link
                            v-if="canViewAdmins"
                            :to="'/admins/' + user.user.pk"
                          >
                            {{ user.user.first_name }}
                            {{ user.user.last_name }}
                          </router-link>
                          <span v-else>
                            {{ user.user.first_name }}
                            {{ user.user.last_name }}
                          </span>
                        </template>
                      </div>
                    </span>
                  </template>
                  <template #item-actions="item">
                    <button
                      v-if="canDeleteGroup"
                      @click.stop="
                        showModal = item.pk;
                        deleteName = item.name;
                      "
                      class="btn btn-danger btn-xs"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                  </template>
                </EasyDataTable>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input type="number" v-model="serverOptions.page" /> -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="serverOptions.page = serverOptions.page - 1"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="serverOptions.page = serverOptions.page + 1"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Modal
    v-if="showModal"
    :title="'Potwierdzenie usunięcia'"
    :content="'Czy na pewno chcesz usunąć <b>' + deleteName + '</b> ?'"
    @callbackOk="deleteGroup(showModal)"
    @callbackClose="showModal = false"
  />
</template>

<script>
import { computed, watch, ref, onMounted } from "vue";
import { useStore } from "vuex";
import Modal from "../caffeprint/Modal.vue";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import { hasPermission } from "../../permissions";
import { modelPermissionsGroupPermissionsConst } from "../../constants/groupConstants";
import { adminPermissionsConst } from "../../constants/userConstants";

export default {
  name: "GroupsList",
  mixins: [],
  components: {
    Modal,
    Multiselect,
  },
  props: {},

  setup() {
    const store = useStore();
    store.dispatch("getPermissions");
    const permissionsGroupsData = computed(
      () => store.getters.getPermissionsGroupsData
    );
    const permissionsGroupData = computed(
      () => store.getters.getPermissionsGroupData
    );
    const deletePermissionsGroupData = computed(
      () => store.getters.getDeletePermissionsGroupData
    );
    const updatePermissionsGroupData = computed(
      () => store.getters.getUpdatePermissionsGroupData
    );
    const permissionsData = computed(() => store.getters.getPermissionsData);
    const adminsPGsData = computed(() => store.getters.getAdminsPGsData);

    const canAddGroup = computed(() =>
      hasPermission(modelPermissionsGroupPermissionsConst.add)
    );
    const canChangeGroup = computed(() =>
      hasPermission(modelPermissionsGroupPermissionsConst.update)
    );
    const canDeleteGroup = computed(() =>
      hasPermission(modelPermissionsGroupPermissionsConst.delete)
    );
    // The group user count links to the admin details view.
    const canViewAdmins = computed(() =>
      hasPermission(adminPermissionsConst.view)
    );

    const groupObj = ref({
      name: "",
      permissions: [],
    });
    let headers = [
      { text: "Nr", value: "pk" },
      {
        text: "Nazwa",
        value: "name",
        sortable: true,
        search: true,
      },
      {
        text: "Ilość użytkowników",
        value: "user_count",
        sortable: true,
      },
      {
        text: "Data dodania",
        value: "date_added",
        sortable: true,
        search: true,
      },
      {
        text: "Data modyfikacji",
        value: "date_modified",
        sortable: true,
        search: true,
      },
      {
        text: "Zmodyfikowano przez",
        value: "last_modified_by",
        sortable: false,
      },
      {
        text: "Utworzono przez",
        value: "created_by",
        sortable: false,
      },
      { text: "Akcje", value: "actions" },
    ];

    let items = ref([]);
    let users = ref([]);
    let usersPk = ref();
    let itemsAll = ref(0);
    const showModal = ref(false);
    const deleteName = ref("");
    const permissionsList = ref([]);
    const loading = ref(true);
    const isSearch = ref(false);
    const rowsPerPage = ref();
    const searchValue = ref({});
    const defRowsPerPage = ref(25);
    const serverOptions = ref({
      page: 1,
      rowsPerPage: defRowsPerPage.value,
    });

    const isMainOpen = ref(true);
    const isEditOpen = ref(true);

    const chevronMainClass = computed(() =>
      isMainOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronEditClass = computed(() =>
      isEditOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );

    const getPermissionsGroups = async () => {
      loading.value = true;
      let sort;
      if (serverOptions.value.sortType === "desc") {
        sort = "-" + serverOptions.value.sortBy;
      } else {
        sort = serverOptions.value.sortBy;
      }
      await store.dispatch("getPermissionsGroups", {
        page: serverOptions.value.page,
        itemsPerPage: serverOptions.value.rowsPerPage,
        ordering: sort,
        search: searchValue.value,
      });
    };

    const deleteGroup = (pk) => {
      if (!canDeleteGroup.value) {
        return;
      }
      showModal.value = false;
      store.dispatch("deletePermissionsGroup", {
        pk: pk,
      });
    };

    const groupUsersList = (pk) => {
      if (pk !== usersPk.value) {
        users.value = [];
        usersPk.value = pk;
        store.dispatch("getAdminsPGs", pk);
      }
    };
    const saveEdit = () => {
      if (!canChangeGroup.value) {
        return;
      }
      store.dispatch("updatePermissionsGroup", groupObj.value);
    };

    const cancel = () => {
      document.querySelector(".expanding")?.click();
    };

    const editGroup = (globalIndex) => {
      cancel();
      const localIndex =
        globalIndex - (serverOptions.value.page - 1) * defRowsPerPage.value;
      store.dispatch("getPermissionsGroup", { pk: items.value[localIndex].pk });
    };

    const search = () => {
      isSearch.value = true;
      if (searchValue.value) {
        selectPage(1);
        setTimeout(() => {
          getPermissionsGroups();
          isSearch.value = false;
        }, 1000);
      }
    };

    const updateSort = () => {
      search.value = true;
    };

    const resetFilters = () => {
      searchValue.value = {};
      serverOptions.value.sortBy = "";
      getPermissionsGroups();
    };

    const selectPage = (page) => {
      serverOptions.value.page = page;
    };

    const setRowsPerPage = () => {
      serverOptions.value.rowsPerPage = rowsPerPage.value;
    };

    onMounted(() => {
      if (localStorage.getItem("groupsSearchValue") !== null) {
        searchValue.value = localStorage.getItem("groupsSearchValue");
        searchValue.value = JSON.parse(searchValue.value);
        isSearch.value = true;
      }
      getPermissionsGroups();
    });

    watch(
      () => searchValue.value,
      function () {
        localStorage.setItem(
          "groupsSearchValue",
          JSON.stringify(searchValue.value)
        );
        getPermissionsGroups();
      },
      { deep: true }
    );

    watch(
      () => permissionsGroupsData.value,
      function (newValue) {
        itemsAll.value = newValue.data.count;
        items.value = [];
        newValue.data.results?.forEach((element) => {
          items.value.push(element);
        });
        loading.value = false;
      }
    );

    watch(
      () => permissionsGroupData.value,
      function (newValue) {
        groupObj.value = newValue.data;
      }
    );

    watch(
      () => deletePermissionsGroupData.value,
      function (newValue) {
        if (newValue.status === 204) {
          store.dispatch("showToaster", {
            type: "success",
            content: "Grupa uprawnień została usunięta",
          });
        }
        getPermissionsGroups();
      }
    );

    watch(
      () => permissionsData.value,
      function (newValue) {
        newValue.data?.forEach((element) => {
          permissionsList.value.push({
            name: "[" + element.pk + "] " + element.name,
            value: element.pk,
          });
        });
      }
    );

    watch(
      () => adminsPGsData.value,
      function (newValue) {
        newValue.data.results.forEach((element) => {
          users.value.push(element);
        });
      }
    );

    watch(
      () => updatePermissionsGroupData.value,
      function (newValue) {
        if (newValue.status === 200) {
          getPermissionsGroups();
          store.dispatch("showToaster", {
            type: "success",
            content: "Dane zostały zaktualizowane",
          });
        }

        cancel();
      }
    );

    watch(
      () => serverOptions.value,
      function () {
        if (!isSearch.value) {
          getPermissionsGroups();
          isSearch.value = false;
        }
      },
      { deep: true }
    );

    return {
      headers,
      items,
      itemsAll,
      loading,
      serverOptions,
      permissionsList,
      showModal,
      deleteGroup,
      deleteName,
      groupObj,
      canAddGroup,
      canChangeGroup,
      canDeleteGroup,
      canViewAdmins,
      cancel,
      editGroup,
      saveEdit,
      groupUsersList,
      users,
      usersPk,
      search,
      searchValue,
      isSearch,
      resetFilters,
      updateSort,
      rowsPerPage,
      selectPage,
      setRowsPerPage,
      isMainOpen,
      isEditOpen,
      chevronMainClass,
      chevronEditClass,
    };
  },
  computed: {},
};
</script>

<style scoped>
.ibox-title {
  position: relative;
}
.ibox-toggle {
  position: absolute;
  right: 15px;
  top: 12px;
  cursor: pointer;
}
</style>
